module.exports = parcelRequire.resolve("bytw4");